import { opaquePublicIdSchema } from '@ballpeek/api/client'
import { createFileRoute } from '@tanstack/react-router'

import { TeamHistoryPage } from '~/features/football-history/history-pages'
import { teamHistoryQueryOptions } from '~/features/football-history/query-options'
import {
  parseTeamHistorySearch,
  teamHistoryRouteSearchSchema,
  teamHistorySearchSchema,
} from '~/features/football-history/search-schema'
import { footballCoreLocale } from '~/lib/navigation/football-core'
import { parsePublicFootballRouteInput } from '~/lib/public-football-read'
import { seo } from '~/utils/seo'

export const Route = createFileRoute('/$locale/_public/teams/$teamId_/history')({
  validateSearch: (search: unknown) => parsePublicFootballRouteInput(teamHistoryRouteSearchSchema, search),
  beforeLoad: ({ params, search }) => {
    parsePublicFootballRouteInput(opaquePublicIdSchema, params.teamId)
    parseTeamHistorySearch(search, footballCoreLocale(params.locale))
  },
  head: ({ params }) => seo({
    title: '球队历史比赛 | BallPeek',
    description: '带有明确资料覆盖范围的有限描述性足球比赛历史。',
    pathname: `/teams/${encodeURIComponent(params.teamId)}/history`,
    locale: params.locale,
  }),
  loader: async ({ context, params, location }) => {
    await context.queryClient.prefetchQuery(
      teamHistoryQueryOptions(params.teamId, teamHistorySearchSchema.parse(location.search)),
    )
  },
  component: LocalizedTeamHistoryRoute,
})

function LocalizedTeamHistoryRoute() {
  const params = Route.useParams()
  return <TeamHistoryPage teamId={params.teamId} search={Route.useSearch()} />
}
